export default "__VITE_ASSET__1zfI5W5v__"